/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CustomsMessaging = "DUTY_EXEMPT" | "NOT_DUTY_EXEMPT" | "NOT_ENOUGH_DATA" | "%future added value";
export type PdpSharedCustomsMessage_item = {
    readonly customsMessaging: {
        readonly message: string | null;
        readonly code: CustomsMessaging | null;
    } | null;
    readonly " $refType": "PdpSharedCustomsMessage_item";
};
export type PdpSharedCustomsMessage_item$data = PdpSharedCustomsMessage_item;
export type PdpSharedCustomsMessage_item$key = {
    readonly " $data"?: PdpSharedCustomsMessage_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedCustomsMessage_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedCustomsMessage_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "customsMessaging",
      "storageKey": null,
      "args": null,
      "concreteType": "CustomsMessagingType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "message",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c11b7b73a27cef7a798d6bc1d233df6c';
export default node;
